import { createBrowserRouter } from 'react-router-dom';
import ProjectRoutes from 'routes/ProjectRoutes';
import ProjectBatchJobsRoutes from 'routes/ProjectBatchJobsRoutes.tsx';
import ProjectCanvasRoutes from 'routes/ProjectCanvasRoutes.tsx';
import RequireAuth from 'auth/RequireAuth.tsx';
import LoginView from 'views/auth/LoginView.tsx';
import ProjectBatchJobExecutionsRoutes from './BatchJobExecutionsRoutes.tsx';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginView />,
  },
  {
    element: <RequireAuth />,
    children: [ProjectRoutes, ProjectBatchJobsRoutes, ProjectCanvasRoutes, ProjectBatchJobExecutionsRoutes],
  },
]);
